// date-fns format
// https://date-fns.org/v2.0.0-alpha.25/docs/format
export const DATE_RANGE_PICKER_FILTER_MENU_DATE_FORMAT = 'P';
//# sourceMappingURL=DateRangePickerFilterMenu.constants.js.map